import {
  AfterViewInit,
  ChangeDetectionStrategy,
  Component,
  computed,
  effect,
  HostListener,
  Input,
  OnInit,
  signal,
  WritableSignal,
} from '@angular/core';
import { NgClass } from '@angular/common';
import { SKUProduct } from '@interfaces/products/sku_product_interface';
import { LnChevronDownSvgIconComponent } from '@components/svg-icons/ln-chevron-down-svg-icon/ln-chevron-down-svg-icon.component';
import { ClickOutSideDirective } from '@directives/click-out-side.directive';

@Component({
  selector: 'ln-dropdown',
  imports: [NgClass, LnChevronDownSvgIconComponent, ClickOutSideDirective],
  templateUrl: './dropdown.component.html',
  styleUrl: './dropdown.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DropdownComponent implements OnInit, AfterViewInit {
  protected options: WritableSignal<string[]> = signal([]);
  protected selected: WritableSignal<string> = signal('');
  protected isOpen: WritableSignal<boolean> = signal(false);
  private computedWidth: WritableSignal<number> = signal(200);
  protected computedWidthInPixel = computed(() => this.computedWidth());
  @Input({ required: true }) products!: SKUProduct[];
  @Input({ required: true }) attributeName!: string;
  @Input({ required: true }) selectedVariant!: WritableSignal<number>;
  private TAG = 'DropdownComponent';
  private readonly SM_DEVICES_SCREEN_WIDTH = 640;
  private readonly IPHONE_14_PRO_MAX_SCREEN_WIDTH = 430;
  protected readonly preventChange = computed(() => this.options().length <= 1);
  constructor() {
    effect(() => {
      this.updateSelectedValue();
    });
  }

  @HostListener('window:resize', ['$event'])
  onScreenResize() {
    this.updateComputedWidth();
  }

  ngAfterViewInit(): void {
    this.updateComputedWidth();
  }

  updateComputedWidth(): void {
    const width = window.innerWidth;
    // console.log(`${this.TAG} updateComputedWidth() width = ${window.innerWidth}`);
    if (width >= this.SM_DEVICES_SCREEN_WIDTH) {
      this.computedWidth.set(280);
    } else if (width >= this.IPHONE_14_PRO_MAX_SCREEN_WIDTH) {
      this.computedWidth.set(250);
    } else {
      this.computedWidth.set(200);
    }
    // console.log(`${this.TAG} updateComputedWidth() width = ${this.computedWidthInPixel()}`);
  }

  ngOnInit(): void {
    this.setOptionsValues();
  }

  setOptionsValues() {
    this.products.forEach(product => {
      const match = product.atributos.find(atributo => atributo.nombre === this.attributeName);

      if (match) {
        this.options().push(match.valor);
      }
    });
  }

  updateSelectedValue() {
    const selectedVariantIndex = this.selectedVariant();
    const match = this.products[selectedVariantIndex].atributos.find(
      atributo => atributo.nombre === this.attributeName
    );
    if (match) {
      this.selected.set(match.valor);
    }
  }

  toggleDropdown() {
    this.isOpen.set(!this.isOpen());
  }

  selectOption(option: string) {
    this.selected.set(option);
    this.isOpen.set(false);
    this.getSelectedVariantIndex();
  }

  closeDropdown() {
    this.isOpen.set(false);
  }

  getSelectedVariantIndex() {
    this.products.forEach(product => {
      const match = product.atributos.find(
        atributo => atributo.nombre === this.attributeName && atributo.valor === this.selected()
      );

      if (match) {
        const selectedVariantIndex = this.products.indexOf(product);
        console.log(`${this.TAG} ${selectedVariantIndex}`);
        this.selectedVariant.set(selectedVariantIndex);
      }
    });
  }
}
